import { Component, ElementRef } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject } from "rxjs";

import { BfxDialogData } from "./models/bfx-dialog-data.model";

import { BfxOrderCancelComponentLauncher } from "../bfx-order-cancel/bfx-order-cancel.launcher";
import { BfxDialogBaseComponent } from "./bfx-dialog-base.component";

import {
  COLUMN_XFER_TARGET_GROUP,
  OrdersTableDefinitionFactory,
  TableDefinition,
} from "shared/cubiq-services";
import { GoldenLayoutService } from "../golden-layout/golden-layout-service";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BfxConfigIDRefHelper } from "../../shared/helper-services/bfx-config-id-ref-helper";
import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";

@Component({
  selector: `bfx-dialog-order-cancel-warning`,
  templateUrl: `./html/bfx-dialog-order-cancel-warning.html`,
  standalone: false,
})
export class BfxDialogOrderCancelWarningComponent extends BfxDialogBaseComponent {
  public title: string = "";
  public confirmationMessage: string = "";
  public messages: Array<string> = [];
  public tableDefinition: TableDefinition = null;
  public callback: any = null;

  public data: any = {
    dialogId: null,
    dialogEventSubject: new Subject<BfxDialogData>(),
    actionEvent: null,
    payload: null,
    dialogData: {
      show: false,
      width: 450,
      count: 0,
    },
  };

  constructor(
    protected layoutService: GoldenLayoutService,
    protected translationService: TranslateService,
    ordersTableDefinitionFactory: OrdersTableDefinitionFactory,
    private element: ElementRef,
  ) {
    super();
    this.tableDefinition = ordersTableDefinitionFactory.createDef();
  }

  public openDialog(_dialogData: BfxDialogData): Observable<any> {
    try {
      this.data.dialogId = _dialogData.dialogId;
      this.data.actionEvent = _dialogData.event;
      this.data.payload = _dialogData.payload;

      let event = this.data.actionEvent;

      if (event != null) {
        if (event.breach) {
          let alone: boolean = event.transferItems == null || event.transferItems.length == 0;
          this.messages.push(
            this.translationService.instant("cancel.breached.multi.message", [
              event.selectedIds.length,
            ]),
          );
          this.title = this.translationService.instant("cancel.breached.title");
        }

        if (!event.transferItems != null && event.transferItems.length > 0) {
          let transferCount: number = event.transferItems.length;
          let message = this.translationService.instant("cancel.transfer.multi.message", [
            transferCount,
          ]);

          if (transferCount == 1) {
            let orderRef: string = BfxConfigIDRefHelper.getOrderRef(event.selectedItems[0]);
            let targetDesk: string = event.transferItems[0][COLUMN_XFER_TARGET_GROUP];
            message = this.translationService.instant("cancel.transfer.single.message", [
              orderRef,
              targetDesk,
            ]);
          }

          this.title = this.translationService.instant("cancel.transfer.title");
          this.messages.push(message);
        }
        this.confirmationMessage = this.translationService.instant(
          "order_entry.dialog.close.subMessage",
        );
      }

      if (this.messages.length > 0) {
        this.title = this.translationService.instant("warning.title");
        this.data.dialogData.count = event.selectedIds.length;
        NativeDesktopSupport.prepareEmbeddedDialog(_dialogData.body, this._dialog, this.element);
        this.data.dialogData.show = true;
      }
    } catch (ex) {
      logger.out.error(
        "ERROR: BfxDialogOrderCancelWarningComponent.openDialog(): Dialog exception! msg:",
        ex,
      );
    }

    return this.data.dialogEventSubject.asObservable();
  }

  public closeDialog(): void {
    super.closeDialog();
    this.data.dialogData.title_text = null;
    this.data.dialogData.message_text = null;
    this.data.dialogData.message_text_ids = null;
    this.data.actionEvent = null;
    this.data.payload = null;
    this.data.dialogData.show = false;
    // inform dialog service that dialog is closed and to cleanup
    this.notifyDialogClosed(this.data.dialogEventSubject, this.data.dialogId);
  }

  public actionConfirmed(event: any): void {
    if (this.data.actionEvent != null) {
      BfxOrderCancelComponentLauncher.launch(
        this.data.actionEvent.selectedItems,
        this.layoutService,
        this.translationService,
        event,
      );
    } else {
      logger.out.error(
        "ERROR: BfxDialogOrderCancelWarningComponent.actionCancelTrade_yes(): Could not cancel orders, action event is null!",
      );
    }
    this.closeDialog();
  }
}
